import { createFileRoute } from '@tanstack/react-router';
import { ScrollText } from 'lucide-react';
import { AuditLogTable } from '@/components/admin-ops/AuditLogTable';

export const Route = createFileRoute('/_admin/auditoria')({
  component: AuditoriaPage,
});

function AuditoriaPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <ScrollText className="h-6 w-6 text-primary" />
          Trilha de Auditoria
        </h1>
        <p className="text-muted-foreground text-sm">
          Histórico completo de ações do sistema
        </p>
      </div>
      <AuditLogTable />
    </div>
  );
}
